import {apiConfig} from '@stencil/hotels-config';

export default function prepareGetUserReviewsUrls(
  hotelId,
  offset = 0,
  limit = 5,
  tagIds = [],
  filter,
  sortBy,
  searchText,
  reviewId,
) {
  let url = `${apiConfig.__UGC__}/api/HotelReviews/forMobileV4/${hotelId}?offset=${offset}&limit=${limit}`;

  if (tagIds.length > 0) {
    url += `&tagIds=${JSON.stringify(tagIds)}`;
  }
  if (filter) {
    url += `&filter=${filter}`;
  }
  if (searchText) url += `&st=${searchText}`;
  if (reviewId) url += `&reviewId=${reviewId}`;

  url += `&sortBy=${sortBy}&webp=true&flavour=dWeb`;

  return url;
}
